/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListQuery } from './listQuery.schema';

export const GetTransmittalDocumentFiles = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => ListQuery).optional()
});

export type GetTransmittalDocumentFiles = zod.input<typeof GetTransmittalDocumentFiles>;
export type GetTransmittalDocumentFilesOutput = zod.output<typeof GetTransmittalDocumentFiles>;
